if(location.pathname == '/cart') {
  document.location.href = '/?return_link=cart';
}

if(location.href.indexOf('return_link=cart') != -1) {
  setTimeout(function() {
    let cartDrawerElement = document.querySelector('cart-drawer');
    
    // if (cartDrawerElement?.classList.contains('is-empty')) {
    //   cartDrawerElement?.classList.remove('is-empty');
    // }
    
    if(document.querySelector('cart-drawer')) {
      document.querySelector('cart-drawer').open();
      document.querySelector('cart-drawer').addFreebie();
    }
  }, 1000);
  
  let currentPageUrl = window.location.href.replace('?return_link=cart', '');
  window.history.replaceState({}, document.title, currentPageUrl);
}

// Cart close on browser back button
function handlePopState(event) {
  const cartDrawerEle = document.querySelector('cart-drawer');
  if (location.href.indexOf('cartOpen=true') == -1 && cartDrawerEle) {
      cartDrawerEle.close();
  } else if(event.state?.cart=='open' && cartDrawerEle) {
      cartDrawerEle.open()
  }
}

window.addEventListener('popstate', handlePopState);

// If someway Url [cartOpen=true] their then remove
document.addEventListener('DOMContentLoaded', () => {
   const cartDrawer = document.querySelector('cart-drawer');
   const url = new URL(location);

   if (!cartDrawer.classList.contains('active') && url.searchParams.has("cartOpen")) {
      let currentPageUrl = window.location.href.replace(/[?&]cartOpen=true/g, '');
      window.history.replaceState({}, document.title, currentPageUrl);
   }
});